import React, { useState } from 'react';
import { Phone, Menu, X, MapPin } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-4">
          {/* Logo */}
          <div className="flex items-center gap-3 min-w-0 flex-shrink-0">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <div className="min-w-0">
              <h1 className="text-base sm:text-lg font-bold text-gray-900 leading-tight whitespace-nowrap">Sparky's Auto Electric</h1>
              <p className="text-xs text-gray-600 flex items-center gap-1 leading-tight">
                <MapPin className="w-3 h-3 flex-shrink-0" />
                <span className="whitespace-nowrap">Beaverton, OR</span>
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            <button onClick={() => scrollToSection('home')} className="text-sm text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-sm text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-sm text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-sm text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
              Reviews
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center flex-shrink-0">
            <a href="tel:5037094366">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 xl:px-6 py-2 text-sm rounded-lg flex items-center gap-2 shadow-lg hover:shadow-xl transition-all whitespace-nowrap">
                <Phone className="w-4 h-4" />
                <span className="hidden xl:inline">(503) 709-4366</span>
                <span className="xl:hidden">Call</span>
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 animate-in slide-in-from-top">
            <nav className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('home')} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors px-4 py-2 hover:bg-gray-50 rounded">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors px-4 py-2 hover:bg-gray-50 rounded">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors px-4 py-2 hover:bg-gray-50 rounded">
                Services
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors px-4 py-2 hover:bg-gray-50 rounded">
                Reviews
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors px-4 py-2 hover:bg-gray-50 rounded">
                Contact
              </button>
              <div className="pt-2 px-4">
                <a href="tel:5037094366" className="block">
                  <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg flex items-center justify-center gap-2">
                    <Phone className="w-4 h-4" />
                    Call (503) 709-4366
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
